import axios from '@/plugins/axios'
import { Module } from 'vuex'

const contentModule: Module<any, any> = {
    actions: {
        async getContent(_, params) {
            let url = '/api/content?'

            url += 'ts=' + Date.now()
            url += params.page ? '&page=' + params.page : ''
            url += params.perPage ? '&itemPerPage=' + params.perPage : ''
            url += params.active ? '&active=true' : ''
            url += params.status ? '&status=' + params.status : ''
            url += params.search ? '&search=' + encodeURIComponent(params.search) : ''
            url += params.owner ? '&owner=' + params.owner : ''
            url += params.suggested ? '&suggested=' + params.suggested : ''
            url += params.network ? '&network=' + params.network : ''
            url += params.execCommsStatus ? '&exec-comms-status=' + params.execCommsStatus : ''            
            url += params.topics ? '&topics=' + params.topics : ''   
            url += params.contentType ? '&contentType=' + params.contentType : ''
            url += params.campaignTags ? '&campaignTags=' + params.campaignTags : ''         
            url += params.sourceTag ? '&sourceTag=' + params.sourceTag : ''
            url += params.expertOpinion ? '&expert-opinion=true' : ''
            url += params.expertOpinionAnswered ? '&expert-opinion-answered=true' : ''
            url += params.feeds ? '&feeds=' + params.feeds : ''            
            url += params.shared ? '&shared=true'  : ''
            url += params.notShared ? '&shared=false' : ''
            url += params.scheduled ? '&scheduled=true' : ''
            url += params.campaign ? '&campaign=true' : ''            
            url += params.pinned ? '&pinned=true' : ''
            url += params.locked ? '&locked=true' : ''            
            url += params.archived ? '&archived=true' : ''
            url += params.showDeleted ? '&includeDeleted=true' : ''
            url += params.deleted ? '&showDeleted=true' : ''
            url += params.createdByIds ? '&createdByIds=' + params.createdByIds : ''
            url += params.dateFrom ? '&dateRange[from]=' + params.dateFrom :''
            url += params.dateTo ? '&dateRange[to]=' + params.dateTo :''
            url += params.excludeSharedByWorkspaceMemberId ? '&excludeSharedByWorkspaceMemberId=' + params.excludeSharedByWorkspaceMemberId : ''
            url += params.approvableByOwner ? '&approvable-by-owner=1' : ''
            url += params.excludeApprovableByOwner ? '&exclude-approvable-by-owner=1' : ''
            url += params.showPinnedFirst ? '&showPinnedFirst=true' : ''
            url += params.sort ? '&sort=' + params.sort : ''
            url += params.order ? '&order=' + params.order : ''

            const { data } = await axios.get(url)

            return data
        },
        
        async exportContent(
            _,
            {
                page,
                perPage,
                search,
                status,
                owner,
                suggested,
                network,
                execCommsStatus,
                archived,
                dateFrom,
                dateTo,
                campaignTags,
                showDeleted,
                createdBy,
                locked,
                unposted,
                archive,
                
            },
        ) {
            let url = '/api/content/export?'

            url += page ? '&page=' + page : ''
            url += perPage ? '&itemPerPage=' + perPage : ''
            url += search ? '&search=' + encodeURIComponent(search) : ''
            url += status ? '&status=' + status : ''
            url += owner ? '&owner=' + owner : ''
            url += suggested ? '&suggested=' + suggested : ''
            url += network ? '&network=' + network : ''
            url += execCommsStatus ? '&exec-comms-status=' + execCommsStatus : ''
            url += archived===true || archived===false ? '&archived=' + archived : ''
            url += '&ts=' + Date.now()
            url += dateFrom ? '&dateRange[from]=' + dateFrom :''
            url += dateTo ? '&dateRange[to]=' + dateTo :''
            url += campaignTags ? '&campaignTags=' + campaignTags : ''
            url += showDeleted ? '&includeDeleted=' + true : ''
            url += createdBy ? '&owner=' + createdBy : ''
            url += locked ? '&locked=' + true : ''
            url += unposted ? '&unposted=' + true : ''
            url += archive ? '&archived=' + true : ''


            const { data } = await axios.get(url)

            return data
        },
        async getContents(_, params) {
        
            const page = params?.contentIds ? 1 : (params?.page ?? 1)
            const perPage = params?.contentIds?.length ?? params?.perPage ?? 20

            let url = `/api/content?page=${page}&itemPerPage=${perPage}`
            url += params?.contentIds ? '&contentIds=' + params.contentIds : ''
            url += params?.includeDeleted
                ? '&includeDeleted=' + params.includeDeleted
                : ''

            const { data } = await axios.get(url)

            return data
        },
        async createContentFromPost(_, params) {
            const { data } = await axios.post('/api/content/create-from-post', params)
            return data
        },
        async createContentFromUrl(_, params) {
            const { data } = await axios.post('/api/content/create-from-url', params)
            return data
        },
        async answerGeneratedQuestion(_, params) {
            const { data } = await axios.put(`/api/content/${params.id}/answer-generated-question`, params)
            return data
        },
        async getContentItem(_, id) {
            const { data } = await axios.get(`/api/content/${id}`)
            return data
        },
        async getContentItemIncludingDeleted(_, id) {
            const { data } = await axios.get(`/api/content/including-deleted/${id}`)
            return data
        },
        async approveContent(_, params) {
            const { data } = await axios.put(`/api/content/${params.id}/approval-status`, {action: 'approve'})
            return data
        },
        async approveContentExec(_, params) {
            const { data } = await axios.put(
                `/api/content/${params.id}/manager/approve`,
                {}
            )
            return data
        },
        async rejectContent(_, params) {
            const { data } = await axios.put(`/api/content/${params.id}/approval-status`, {action: 'reject', note: params.note})
            return data
        },
        async rejectContentExec(_, params) {
            const { data } = await axios.put(
                `/api/content/${params.id}/manager/reject`,
                { note: params.note },
            )
            return data
        },
        async suggestContent(_, params) {
            const { data } = await axios.put(
                `/api/content/approval-status/${params.id}`,
                { action: 'suggest' },
            )
            return data
        },
        async suggestContentExec(_, params) {
            const { data } = await axios.put(
                `/api/content/${params.id}/manager/change`,
                { note: params.note },
            )
            return data
        },
        async submitContentForExecApproval(_, params) {
            const { data } = await axios.put(
                `/api/content/${params.id}/manager/submit-for-owner-review`,
                {},
            )
            return data
        },
        async duplicateContent(_, id) {
            const { data } = await axios.put(`/api/content/${id}/duplicate`, {})
            return data
        },
        async copyToContent(_, params) {
            const { data } = await axios.put(`/api/content/${params.id}/copy-to`, params)
            return data
        },
        async deleteContent(_, { id }) {
            const { data } = await axios.delete(`/api/content/${id}`)
            return data
        },
        async hardDeleteContent(_, { id }) {
            const { data } = await axios.delete(`/api/content/${id}/hard_delete`)
            return data
        },
        // Each of its published posts comes down and goes to its member's Emergency Bin; then the content is deleted
        async emergencyDeleteContent(_, { id }) {
            const { data } = await axios.delete(`/api/content/${id}/emergency`, { silent: true })
            return data
        },
        async persistContent(_, params) {
            if (params.id) {
                const { data } = await axios.put(
                    `/api/content/${params.id}`,
                    params,
                )
                return data
            } else {
                const { data } = await axios.post('/api/content', params)
                return data
            }
        },
        async multiEditContent(_, params) {            
            const { data } = await axios.post(
                '/api/content/multiedit',
                params,
            )
            return data
        },
        async submitContentForReview(_, id) {
            const { data } = await axios.put(
                `/api/content/${id}/manager/submit-for-review`,
                {}
            )
            return data
        },
        async updateContentTopics(_, { id, topics }) {
            const { data } = await axios.put(`/api/content/${id}/topics`, {
                topics,
            })
            return data
        },
        async assignContentTopic(_, { id, slug, assign }) {
            const { data } = await axios.put(`/api/content/${id}/topic`, {
                slug,
                assign,
            })
            return data
        },
        async updateContentCampaignTags(_, { id, tags }) {
            const { data } = await axios.put(
                `/api/content/${id}/campaign_tags`,
                { campaignTags: tags },
            )
            return data
        },
        async assignContentCampaignTag(_, { id, slug, assign }) {
            const { data } = await axios.put(
                `/api/content/${id}/campaign_tag`,
                { slug, assign },
            )
            return data
        },
        async archiveContent(_, { id, archive }) {
            const { data } = await axios.put(`/api/content/${id}/archive`, {
                archive,
            })
            return data
        },
        async reactivateContent(_, { id, reactivate }) {
            const { data } = await axios.put(`/api/content/${id}/reactivate`, {
                reactivate,
            })
            return data
        },
        async pinContent(_, { id, pin }) {
            const { data } = await axios.put(`/api/content/${id}/pin`, {
                pin,
            })
            return data
        },
        async generateContentQuestions(_, params) {
            const { data } = await axios.put(`/api/content/${params.id}/generate-questions`, params)
            return data
        },
        async selectContentQuestion(_, params) {
            const { data } = await axios.put(`/api/content/${params.id}/generated-question-send`, params)
            return data
        },
    },
}

export default contentModule
